// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type HypotheticalInsuranceDestinationsQueryVariables = Types.Exact<{
  householdID: Types.Scalars['ID']['input'];
}>;


export type HypotheticalInsuranceDestinationsQuery = { __typename?: 'Query', entities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: { __typename?: 'Entity', id: string, stage: Types.EntityStage, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } } | null } | null> | null } };

export const Operations = {
  Query: {
    HypotheticalInsuranceDestinations: 'HypotheticalInsuranceDestinations' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const HypotheticalInsuranceDestinationsDocument = gql`
    query HypotheticalInsuranceDestinations($householdID: ID!) {
  entities(
    where: {kindIn: [INSURANCE_PERSONAL_ACCOUNT, CCORP_BUSINESS_ENTITY, GP_BUSINESS_ENTITY, LP_BUSINESS_ENTITY, LLC_BUSINESS_ENTITY, SCORP_BUSINESS_ENTITY, CLT_TRUST, CRT_TRUST, DONOR_ADVISED_FUND, PRIVATE_FOUNDATION, IRREVOCABLE_TRUST, REVOCABLE_TRUST, SLAT_TRUST, ILIT_TRUST], stageIn: [ACTIVE, DRAFT], hasHouseholdWith: [{id: $householdID}]}
  ) {
    edges {
      node {
        id
        stage
        subtype {
          id
          displayName
        }
      }
    }
  }
}
    `;

/**
 * __useHypotheticalInsuranceDestinationsQuery__
 *
 * To run a query within a React component, call `useHypotheticalInsuranceDestinationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHypotheticalInsuranceDestinationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHypotheticalInsuranceDestinationsQuery({
 *   variables: {
 *      householdID: // value for 'householdID'
 *   },
 * });
 */
export function useHypotheticalInsuranceDestinationsQuery(baseOptions: Apollo.QueryHookOptions<HypotheticalInsuranceDestinationsQuery, HypotheticalInsuranceDestinationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HypotheticalInsuranceDestinationsQuery, HypotheticalInsuranceDestinationsQueryVariables>(HypotheticalInsuranceDestinationsDocument, withFetchPolicyContext(options));
      }
export function useHypotheticalInsuranceDestinationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HypotheticalInsuranceDestinationsQuery, HypotheticalInsuranceDestinationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HypotheticalInsuranceDestinationsQuery, HypotheticalInsuranceDestinationsQueryVariables>(HypotheticalInsuranceDestinationsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useHypotheticalInsuranceDestinationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HypotheticalInsuranceDestinationsQuery, HypotheticalInsuranceDestinationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HypotheticalInsuranceDestinationsQuery, HypotheticalInsuranceDestinationsQueryVariables>(HypotheticalInsuranceDestinationsDocument, withFetchPolicyContext(options));
        }
export type HypotheticalInsuranceDestinationsQueryHookResult = ReturnType<typeof useHypotheticalInsuranceDestinationsQuery>;
export type HypotheticalInsuranceDestinationsLazyQueryHookResult = ReturnType<typeof useHypotheticalInsuranceDestinationsLazyQuery>;
export type HypotheticalInsuranceDestinationsSuspenseQueryHookResult = ReturnType<typeof useHypotheticalInsuranceDestinationsSuspenseQuery>;
export type HypotheticalInsuranceDestinationsQueryResult = Apollo.QueryResult<HypotheticalInsuranceDestinationsQuery, HypotheticalInsuranceDestinationsQueryVariables>;